export const INFO: { value: string; label: string }[] = [
  {
    label: "Name",
    value: "Hồ Văn Đoan",
  },
  {
    label: "Tuổi",
    value: "24",
  },
  {
    label: "Nghề nghiệp",
    value: "Web Developer",
  },
  {
    label: "LinkedIn",
    value: "kansoul",
  },
  {
    label: "Kinh nghiệm",
    value: "3+ năm",
  },
  {
    label: "Facebook",
    value: "ZaikDG",
  },
  {
    label: "Số điện thoại",
    value: "+84 378 999 262",
  },
  {
    label: "Quê quán",
    value: "Tỉnh Đăk Lăk, Việt Nam.",
  },
  {
    label: "Địa chỉ",
    value: "Hải Châu, TP. Đà Nẵng, Việt Nam.",
  },
];

export const FRIENDS: {
  href: string;
  name: string;
  role: string;
  image: string;
}[] = [
  {
    href: "https://ducxinh.com/",
    name: "Nguyễn Đức Xinh",
    role: "Full-stack Developer",
    image: "/images/friends/anhxinh.jpg",
  },
  {
    href: "https://phamvantu.com/",
    name: "Phạm Văn Tú",
    role: "Frontend Developer",
    image: "/images/friends/phamvantu.jpg",
  },
  {
    href: "https://thanhtrungit.net/",
    name: "Thành Trung IT",
    role: "Backend Developer",
    image: "/images/friends/thanhtrung.jpg",
  },
  {
    href: "https://www.hoangson.space/",
    name: "Hoàng Sơn Space",
    role: "Frontend Developer",
    image: "/images/friends/sonspace.jpg",
  },
  {
    href: "https://www.facebook.com/phucDuyKhang",
    name: "Trương Khang",
    role: "Backend Developer",
    image: "/images/friends/khang.png",
  },
];

export const PRODUCTS = [
  {
    title: "Moonbeam",
    link: "https://gomoonbeam.com",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/moonbeam.png",
  },
  {
    title: "Cursor",
    link: "https://cursor.so",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/cursor.png",
  },
  {
    title: "Rogue",
    link: "https://userogue.com",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/rogue.png",
  },

  {
    title: "Editorially",
    link: "https://editorially.org",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/editorially.png",
  },
  {
    title: "Editrix AI",
    link: "https://editrix.ai",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/editrix.png",
  },
  {
    title: "Pixel Perfect",
    link: "https://app.pixelperfect.quest",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/pixelperfect.png",
  },

  {
    title: "Algochurn",
    link: "https://algochurn.com",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/algochurn.png",
  },
  {
    title: "Aceternity UI",
    link: "https://ui.aceternity.com",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/aceternityui.png",
  },
  {
    title: "Tailwind Master Kit",
    link: "https://tailwindmasterkit.com",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/tailwindmasterkit.png",
  },
  {
    title: "SmartBridge",
    link: "https://smartbridgetech.com",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/smartbridge.png",
  },
  {
    title: "Renderwork Studio",
    link: "https://renderwork.studio",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/renderwork.png",
  },

  {
    title: "Creme Digital",
    link: "https://cremedigital.com",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/cremedigital.png",
  },
  {
    title: "Golden Bells Academy",
    link: "https://goldenbellsacademy.com",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/goldenbellsacademy.png",
  },
  {
    title: "Invoker Labs",
    link: "https://invoker.lol",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/invoker.png",
  },
  {
    title: "E Free Invoice",
    link: "https://efreeinvoice.com",
    thumbnail:
      "https://aceternity.com/images/products/thumbnails/new/efreeinvoice.png",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "It was the best of times, it was the worst of times, it was the age of wisdom, it was the age of foolishness, it was the epoch of belief, it was the epoch of incredulity, it was the season of Light, it was the season of Darkness, it was the spring of hope, it was the winter of despair.",
    name: "Charles Dickens",
    title: "A Tale of Two Cities",
  },
  {
    quote:
      "To be, or not to be, that is the question: Whether 'tis nobler in the mind to suffer The slings and arrows of outrageous fortune, Or to take Arms against a Sea of troubles, And by opposing end them: to die, to sleep.",
    name: "William Shakespeare",
    title: "Hamlet",
  },
  {
    quote: "All that we see or seem is but a dream within a dream.",
    name: "Edgar Allan Poe",
    title: "A Dream Within a Dream",
  },
  {
    quote:
      "It is a truth universally acknowledged, that a single man in possession of a good fortune, must be in want of a wife.",
    name: "Jane Austen",
    title: "Pride and Prejudice",
  },
  {
    quote:
      "Call me Ishmael. Some years ago—never mind how long precisely—having little or no money in my purse, and nothing particular to interest me on shore, I thought I would sail about a little and see the watery part of the world.",
    name: "Herman Melville",
    title: "Moby-Dick",
  },
];

export const SKILLS: {
  iconUrl: string;
  name: string;
  percent: string;
}[] = [
  {
    name: "HTML",
    iconUrl: "/icons/skills/html_css_js.svg",
    percent: "90%",
  },
  {
    name: "Next JS",
    iconUrl: "/icons/skills/nextjs.svg",
    percent: "90%",
  },
  {
    name: "React JS",
    iconUrl: "/icons/skills/react.svg",
    percent: "90%",
  },
  {
    name: "Tailwind",
    iconUrl: "/icons/skills/tailwindcss.svg",
    percent: "90%",
  },
  {
    name: "Laravel",
    iconUrl: "/icons/skills/laravel.svg",
    percent: "90%",
  },
  {
    name: "Express",
    iconUrl: "/icons/skills/nodejs.svg",
    percent: "60%",
  },
  {
    name: "WordPress",
    iconUrl: "/icons/skills/wordpress.svg",
    percent: "85%",
  },

  {
    name: "Mongo",
    iconUrl: "/icons/skills/mongo.svg",
    percent: "70%",
  },
  {
    name: "MySQL",
    iconUrl: "/icons/skills/mysql.svg",
    percent: "90%",
  },

  {
    name: "Nginx",
    iconUrl: "/icons/skills/nginx.svg",
    percent: "80%",
  },
  {
    name: "Server",
    iconUrl: "/icons/skills/server.svg",
    percent: "80%",
  },
  {
    name: "AWS",
    iconUrl: "/icons/skills/aws.svg",
    percent: "20%",
  },
];

export const MOBILE_NAV_ITEMS: {
  id: number;
  navTitle: string;
}[] = [
  {
    id: 0,
    navTitle: "home",
  },
  {
    id: 1,
    navTitle: "showreel",
  },
  {
    id: 2,
    navTitle: "services",
  },
  {
    id: 3,
    navTitle: "about",
  },
  {
    id: 4,
    navTitle: "contact",
  },
];
